import { EventType } from "../event-type";

export class MatingType extends EventType {
    public static readonly ARTIFICIAL = new MatingType('artificialMating', 'Inseminação artificial');
    public static readonly NATURAL = new MatingType('naturalMating', 'Monta natural');
    public static readonly IMPLANTATION = new MatingType('implantationMating', 'Implantação');

    private constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly iconPath: string = EventType.MATING.iconPath,
        public readonly backgroundColor: string = EventType.MATING.backgroundColor
    ) {
        super(name, label, iconPath, backgroundColor);
    }

    public static get(name: string): MatingType {
        const type = Object.values(MatingType).find((it) => it.name === name);
        if (type == null) {
            throw new Error(`${name} is not a mapped MatingType.`);
        }
        return type;
    }

    public static getSelectableTypes(): MatingType[] {
        return [this.ARTIFICIAL, this.NATURAL];
    }
}
